export const defaultFormData = {
  phoneNumber: '',
  firstName: '',
  lastName: '',
  ssn: '',
  homeAddress: '',
  userId: ''
};
